// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider-1BUZP","clear":"clear-3JrqS"};